import { FC, useEffect, useState } from "react"
import { Link } from "react-router-dom"

import BBSwitch from "../../form/Switch"
import { formatDateTimeFromTimestamp } from "../../../utils"
import { UserDetails } from "../../../../types"

interface Props {
  info: UserDetails
  isNotificationsEnabled?: boolean
  onEnableNotification: (enable: boolean) => void
}

const OtherInfo: FC<Props> = ({
  info,
  isNotificationsEnabled,
  onEnableNotification
}) => {
  /*
    notificationsEnabled state is used to toggle the BBSwitch component immediately
    to reflect the change in the UI instead of waiting for response from backend 
  */
  const [notificationsEnabled, setNotificationsEnabled] = useState<
    boolean | undefined
  >(isNotificationsEnabled)

  useEffect(() => {
    setNotificationsEnabled(isNotificationsEnabled)
  }, [isNotificationsEnabled])

  return (
    <div className="pt-12">
      <div className="flex items-center justify-between pb-4 border-b border-neutral-200">
        <div className="text-lg font-bold">Other Information</div>
      </div>
      <div className="pt-6">
        <div className="text-neutral-400">
          Joined BankingBridge on&nbsp;
          {formatDateTimeFromTimestamp(info.created, "dd LLLL yyyy")}
        </div>
        {notificationsEnabled !== undefined && (
          <div className="pt-6">
            <BBSwitch
              enabled={notificationsEnabled}
              setEnabled={() => {
                setNotificationsEnabled(!notificationsEnabled)
                onEnableNotification(!notificationsEnabled)
              }}
              label="Enable BankingBridge notifications"
              description="By enabling you will be receiving email notifications."
            />
          </div>
        )}
        <div className="pt-6 pb-12">
          <div className="text-neutral-900 font-medium">Member of</div>
          <div>
            {info.org?.brands?.map(b => (
              <div key={b.id}>
                <Link className="text-primary-500" to={`/brands/${b.id}`}>
                  {b.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OtherInfo
